const Vue = require('vue')

Vue.component('form-context-name', {
    template: `<span>{{ internal$context.path }}</span>`
})

Vue.component('form-context', {
    created () {
        this.change()
    },
    props: {
        name: {
            type: [Number, String]
        },
        append: {
            type: Boolean,
            default: false
        },
        root: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        change () {
            let arrayPath = [this.name]

            if (this.root || !this.append || !this.internal$context) {
                const [head, ...tail] = arrayPath
                this.internal$directContext = {
                    arrayPath,
                    path: head + (tail.length ? `^${tail.join('/')}` : ''),
                    name: this.name,
                    root: this.name
                }
            } else if (this.append && this.internal$context) {
                arrayPath = [...this.internal$context.arrayPath, ...arrayPath]
                const [head, ...tail] = arrayPath
                this.internal$directContext = {
                    arrayPath,
                    path: head + (tail.length ? `^${tail.join('/')}` : ''),
                    name: this.name,
                    root: this.internal$context && (this.internal$context.root || this.internal$context.name)
                }
            }

            if (this.internal$context) {
                this.$on(`form-context:${this.internal$context.path}:changed`, this.parentChanged)
            }
        },
        parentChanged ([newParentContext, oldParentContext]) {
            const old = Vue.util.extend({}, this.internal$directContext)

            this.$off(`form-context:${oldParentContext.path}:changed`, this.parentChanged)

            this.change()

            this.$broadcast(`form-context:${old.path}:changed`, [this.internal$directContext, old])

            return true
        }
    },
    watch: {
        append () {
            this.change()
        },
        name () {
            const old = Vue.util.extend({}, this.internal$directContext)
            this.change()
            this.$broadcast(`form-context:${old.path}:changed`, [this.internal$directContext, old])
        }
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/context.js